import { StyleProp, ViewStyle, TouchableOpacity, StyleSheet } from 'react-native'
import { color } from '../../../theme'
import { DS } from '../../../design-system'

type DrawerLabelValueProps = {
  label: string
  value: string
  onPress?: () => void
  style?: StyleProp<ViewStyle>
  disabled?: boolean
}

export const DrawerLabelValue = ({ label, value, style = {}, onPress, disabled }: DrawerLabelValueProps) => {
  return (
    <TouchableOpacity onPress={onPress} style={[styles.container, style]}>
      <DS.Text variant="Body Medium/Regular">{label}</DS.Text>
      <DS.Frame style={styles.chipContainer}>
        <DS.Text variant="Mini/Bold">{value.toUpperCase()}</DS.Text>
      </DS.Frame>
    </TouchableOpacity>
  )
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    gap: DS.spacing[8]
  },
  chipContainer: {
    gap: DS.spacing[8],
    paddingHorizontal: DS.spacing[8],
    borderRadius: 16,
    backgroundColor: color.palette.lightGrey,
    alignItems: 'center',
    justifyContent: 'center'
  }
})
